<template>
  <div class="error">
    <img src="../../assets/img/error.png" />
    <h1>出错啦！</h1>
    <p>页面失联了，攻城狮正在紧急搜索中...</p>
  </div>
</template>
<script>
export default {
  name: "Error",
  data() {
    return { error_text: null };
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.error {
  text-align: center;
  img {
    width: 3rem;
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
  h1 {
    font-family: "Open Sans", sans-serif;
    color: #666666;
    text-align: center;
    font-weight: 400;
    font-size: 0.58rem;
    opacity: 1;
  }
  p {
    text-align: center;
    font-family: "Open Sans", sans-serif;
    color: #9a9a9a;
    font-size: 0.4rem;
    padding: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ErrorPage/Error.vue